/**
 * Invisible-character hygiene for streamed text.
 *
 * Split out of `../messageTimeline.ts`. A text part made only of zero-width
 * characters is non-empty to `length` and blank on screen — the Slack stream
 * seed is a bare ZWSP — so without this a mid-stream marker wedges an empty
 * prose block between two tool runs and splits what should be one run.
 */

/**
 * Zero-width / invisible code points (ZWSP is the Slack stream seed) that make a
 * string non-empty while rendering as nothing. Built from code points so the
 * source carries no literal invisible glyphs.
 */
const INVISIBLE_CODE_POINTS = [0x200b, 0x200c, 0x200d, 0x2060, 0xfeff, 0x00ad];

const INVISIBLE_CHARS = new RegExp(
  `[${INVISIBLE_CODE_POINTS.map((cp) => `\\u${cp.toString(16).padStart(4, '0')}`).join('')}]`,
  'g'
);

export function stripInvisibleChars(text: string): string {
  return text.replace(INVISIBLE_CHARS, '');
}
